// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"8546c1be","239":"ad40150f","435":"1a97bff0","455":"11a7d635","596":"52d4c899","699":"41a4ddfb","977":"29f78a79"}[chunkId] + ".chunk.js";
};